import type { Locale } from '@/intl/types'
import type { GroupBookingData } from '@/scopes/account/group-responsible/domain/types'
import type { GroupBookingAPIResponse } from '@/scopes/account/group-responsible/infrastructure/types'
import { ACCOUNT_GROUP_RESPONSIBLE_IMAGE_SRC } from '@/scopes/account/common/constants'
import { getPeriod } from './utils'

export function mapGroup(data: GroupBookingAPIResponse['data'], locale?: Locale): GroupBookingData['group'] {
  return {
    name: data.groupName ?? '',
    location: '', // TODO: Retrieve from API MS-5143
    period: data.startDate && data.endDate ? getPeriod(data.startDate, data.endDate, locale) : '',
    startingDate: data.startDate ?? '',
    endingDate: data.endDate ?? '',
    imgSrc: ACCOUNT_GROUP_RESPONSIBLE_IMAGE_SRC,
    publicationCode: data.publicationCode ?? '',
    subscriptionModel: ['ClosedActive', 'ClosedPassive'].includes(data.subscriptionModelEnum ?? '') ? 'Closed' : 'Open',
    isBlocked: data.status === 'Blocked',
    masterBookingNumber: data.masterBookingNumber,
  }
}
